'use client';

import { useEffect, useRef } from 'react';

import type { GTMEvents } from '@lib/utils/gtm/gtmEvents';
import sendGTMEvent from '@lib/utils/gtm/sendGTMEvent';

interface Props {
  event?: GTMEvents;
  data?: {
    [key: string]: unknown;
  };
  email?: string;
  phone?: string;
}

/**
 * * Helper component to send page view events to Google Tag Manager
 *
 * @param event - The event name to send to GTM
 * @param data - The data to send with the event
 * @returns null
 */
export default function ViewEvent({ event, data, email, phone }: Props) {
  const ref = useRef<string>(null);

  useEffect(() => {
    // hash event and data to store in ref
    const hash = btoa(JSON.stringify({ event, data }));

    if (ref.current !== hash && !!event) {
      ref.current = hash;

      sendGTMEvent({
        event,
        data,
        email,
        phone_number: phone,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, JSON.stringify(data)]);

  return null;
}
